/*
  facet-range.js (Bass-Tokyo CX) v4
  Renders selected numeric metafield checkbox filters as a Price-style dual
  range slider. Shopify only offers a native slider for Price, so we keep the
  native checkboxes (hidden), tick every one inside the chosen range and fire
  the form's normal AJAX submit. Filtering stays 100% native (OR across values).

  v3: (1) handles step over VALUE INDEXES, not raw numbers, so mixed-catalogue
  collections (3.2oz .. 140.6oz) no longer squash the useful range into a few
  pixels; the number boxes still take real values and snap to existing ones.
  (2) The N active-filter chips Shopify renders for the N ticked values are
  hidden and replaced by one "Weight(Oz): 10.1 - 19.9 x" chip that clears the
  whole range. Chips are matched by diffing each chip href against the current
  query string, so renaming the filter in Search & Discovery cannot break it.

  v4: rolled the slider out from Weight(Oz) alone to Recovery(IPT),
  Max Drag(Lb.) and Gear Ratio as well - see RANGE_KEYS below. Everything is
  per-group (values, slider, summary, chip bucket), so the four sliders are
  independent and combine as native AND-across-filters.

  Self-heals after every AJAX facet re-render. Desktop + mobile forms.
*/
(function () {
  // namespace.key as it appears in "filter.<p|v>.m.<namespace.key>".
  // These are VARIANT metafields on this store. Every numeric filter listed
  // here is rendered as a dual range slider; the label on the slider and on
  // the merged chip is read from Shopify, so renaming a filter in Search &
  // Discovery needs no change here - only the namespace.key must match.
  var RANGE_KEYS = [
    'custom1.weight_oz_',   // Weight(Oz)     number_decimal
    'custom.recovery_ipt_', // Recovery(IPT)  number_integer
    'custom.max_drag_lb_',  // Max Drag(Lb.)  number_decimal
    'custom.gear_ratio'     // Gear Ratio     number_decimal
  ];

  var DASH = '–';
  var CHIP_CLASS = 'facet-range-chip';

  function keyFromName(name) {
    var m = name && name.match(/filter\.[pv]\.m\.(.+)$/);
    return m ? m[1] : null;
  }
  function isRangeName(name) {
    var k = keyFromName(name);
    return !!k && RANGE_KEYS.indexOf(k) !== -1;
  }
  function paramNameOf(group) {
    var cb = group.querySelector('input[type="checkbox"]');
    return cb && cb.name ? cb.name : null;
  }
  function fmt(n) {
    return (Math.round(n * 100) / 100).toString();
  }
  // Dawn re-focuses the input that fired the change, which for us is a
  // checkbox buried deep in the (hidden) value list - the browser scrolls it
  // into view and the page jumps to the bottom of the grid. Dawn skips that
  // focus when the event came from a text input, so every update is fired
  // from this unnamed (=never submitted), visually empty text input instead.
  function ensureTrigger(group) {
    var t = group.querySelector('.facet-range__trigger');
    if (t) return t;
    t = document.createElement('input');
    t.type = 'text';
    t.className = 'facet-range__trigger';
    t.tabIndex = -1;
    t.setAttribute('aria-hidden', 'true');
    group.appendChild(t);
    return t;
  }
  // Firing from the hidden text input also means Dawn no longer restores focus
  // after the re-render, so keyboard users would lose the slider after one
  // arrow key. Remember which control was in use and re-focus it once the
  // slider is rebuilt - with preventScroll so the viewport still never moves.
  var refocus = null;
  function fireUpdate(group) {
    var act = document.activeElement;
    refocus = act && group.contains(act) && /facet-range__(input|num)/.test(act.className)
      ? { name: paramNameOf(group), cls: act.className }
      : null;
    ensureTrigger(group).dispatchEvent(new Event('input', { bubbles: true }));
  }
  function restoreFocus(group, name, wrap) {
    if (!refocus || refocus.name !== name) return;
    var sel = '.' + refocus.cls.trim().split(/\s+/).join('.');
    var el = wrap.querySelector(sel);
    refocus = null;
    if (el && el.focus) el.focus({ preventScroll: true });
  }
  function labelFrom() {
    return (window.__facetRangeLabels && window.__facetRangeLabels.from) || 'From';
  }
  function labelTo() {
    return (window.__facetRangeLabels && window.__facetRangeLabels.to) || 'To';
  }
  function collectValues(group) {
    var vals = [];
    group.querySelectorAll('input[type="checkbox"]').forEach(function (b) {
      var n = parseFloat(b.value);
      if (!isNaN(n)) vals.push({ box: b, num: n });
    });
    vals.sort(function (a, b) { return a.num - b.num; });
    return vals;
  }

  function enhance(group) {
    var name = paramNameOf(group);
    if (!name || !isRangeName(name)) return;
    // Guard on the slider DOM, not a flag: Dawn reuses the group element but
    // replaces its markup, so a flag would survive while the slider is wiped.
    if (group.querySelector('.facet-range')) return;

    var vals = collectValues(group);
    if (vals.length < 2) return;

    var last = vals.length - 1;
    var lowest = vals[0].num;
    var highest = vals[last].num;

    var checkedIdx = [];
    vals.forEach(function (v, i) { if (v.box.checked) checkedIdx.push(i); });
    var loI = checkedIdx.length ? checkedIdx[0] : 0;
    var hiI = checkedIdx.length ? checkedIdx[checkedIdx.length - 1] : last;

    var list = group.querySelector('ul');
    if (!list) return;
    list.style.display = 'none';

    var wrap = document.createElement('div');
    wrap.className = 'facet-range';
    wrap.innerHTML =
      '<div class="facet-range__track">' +
        '<div class="facet-range__rail"><div class="facet-range__fill"></div></div>' +
        '<input type="range" class="facet-range__input facet-range__input--min" min="0" max="' + last + '" step="1" value="' + loI + '" aria-label="' + labelFrom() + '">' +
        '<input type="range" class="facet-range__input facet-range__input--max" min="0" max="' + last + '" step="1" value="' + hiI + '" aria-label="' + labelTo() + '">' +
      '</div>' +
      '<div class="facet-range__fields">' +
        '<span class="facet-range__field"><label>' + labelFrom() + '</label>' +
          '<input type="number" class="facet-range__num facet-range__num--min" inputmode="decimal" step="any" min="' + lowest + '" max="' + highest + '" value="' + fmt(vals[loI].num) + '"></span>' +
        '<span class="facet-range__field"><label>' + labelTo() + '</label>' +
          '<input type="number" class="facet-range__num facet-range__num--max" inputmode="decimal" step="any" min="' + lowest + '" max="' + highest + '" value="' + fmt(vals[hiI].num) + '"></span>' +
      '</div>';

    list.parentElement.insertBefore(wrap, list);

    var rMin = wrap.querySelector('.facet-range__input--min');
    var rMax = wrap.querySelector('.facet-range__input--max');
    var nMin = wrap.querySelector('.facet-range__num--min');
    var nMax = wrap.querySelector('.facet-range__num--max');
    var fill = wrap.querySelector('.facet-range__fill');

    function paintFill() {
      var span = last || 1;
      var a = Number(rMin.value) / span * 100;
      var b = Number(rMax.value) / span * 100;
      fill.style.left = Math.max(0, Math.min(100, a)) + '%';
      fill.style.right = Math.max(0, Math.min(100, 100 - b)) + '%';
    }

    function syncFromSlider(which) {
      var a = Number(rMin.value), b = Number(rMax.value);
      if (a > b) {
        if (which === 'min') { rMin.value = b; a = b; }
        else { rMax.value = a; b = a; }
      }
      nMin.value = fmt(vals[a].num);
      nMax.value = fmt(vals[b].num);
      paintFill();
    }

    // Typed numbers snap inward: low rounds up to the first existing value at
    // or above it, high rounds down, so the span is never widened.
    function idxAtOrAbove(x) {
      for (var i = 0; i <= last; i++) if (vals[i].num >= x - 1e-9) return i;
      return last;
    }
    function idxAtOrBelow(x) {
      for (var i = last; i >= 0; i--) if (vals[i].num <= x + 1e-9) return i;
      return 0;
    }

    function syncFromNum() {
      var a = parseFloat(nMin.value);
      var b = parseFloat(nMax.value);
      if (isNaN(a)) a = lowest;
      if (isNaN(b)) b = highest;
      if (a > b) { var t = a; a = b; b = t; }
      var ai = idxAtOrAbove(a);
      var bi = idxAtOrBelow(b);
      if (ai > bi) { ai = bi = Math.min(ai, bi); }
      rMin.value = ai;
      rMax.value = bi;
      nMin.value = fmt(vals[ai].num);
      nMax.value = fmt(vals[bi].num);
      paintFill();
    }

    function apply() {
      var a = Number(rMin.value), b = Number(rMax.value);
      if (a > b) { var t = a; a = b; b = t; }
      var isFull = (a <= 0 && b >= last);
      var changed = false;
      vals.forEach(function (v, i) {
        var want = !isFull && i >= a && i <= b;
        if (v.box.checked !== want) {
          v.box.checked = want;
          changed = true;
        }
      });
      if (!changed) return;
      fireUpdate(group);
    }

    rMin.addEventListener('input', function () { syncFromSlider('min'); });
    rMax.addEventListener('input', function () { syncFromSlider('max'); });
    rMin.addEventListener('change', apply);
    rMax.addEventListener('change', apply);
    nMin.addEventListener('change', function () { syncFromNum(); apply(); });
    nMax.addEventListener('change', function () { syncFromNum(); apply(); });

    paintFill();
    group.setAttribute('data-range-enhanced', '1');
    restoreFocus(group, name, wrap);
  }

  // Count only non-empty filter.* params: Dawn leaves empty
  // filter.v.price.gte= / .lte= in the address bar but omits them from chip
  // hrefs, so a naive diff saw extra dropped params and rejected every chip.
  function filterCounts(qs) {
    var c = {};
    (qs || '').replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var eq = p.indexOf('=');
      var k = eq === -1 ? p : p.slice(0, eq);
      var v = eq === -1 ? '' : p.slice(eq + 1);
      if (!v) return;
      if (k.indexOf('filter.') !== 0) return;
      c[k] = (c[k] || 0) + 1;
    });
    return c;
  }

  // A chip's href is the current query string minus its own value, so the param
  // that drops exactly one occurrence identifies it. "Remove all" drops many,
  // so it returns null.
  function reducedName(cur, href) {
    var i = href.indexOf('?');
    var h = filterCounts(i === -1 ? '' : href.slice(i + 1));
    var found = null;
    for (var k in cur) {
      var d = cur[k] - (h[k] || 0);
      if (d === 0) continue;
      if (d !== 1 || found) return null;
      found = k;
    }
    return found;
  }

  function hrefWithout(name) {
    var parts = location.search.replace(/^\?/, '').split('&').filter(function (p) {
      return p && p.split('=')[0] !== name;
    });
    return location.pathname + (parts.length ? '?' + parts.join('&') : '');
  }

  function formFor(af) {
    var id = af.classList.contains('active-facets-mobile')
      ? 'FacetFiltersFormMobile'
      : 'FacetFiltersForm';
    return document.getElementById(id) || document.getElementById('FacetFiltersForm');
  }

  function checkedNums(form, name) {
    var out = [];
    if (!form) return out;
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (b) {
      if (b.name !== name) return;
      var n = parseFloat(b.value);
      if (!isNaN(n)) out.push(n);
    });
    out.sort(function (a, b) { return a - b; });
    return out;
  }

  // Dawn's group heading shows the number of ticked values, which for a range
  // reads as a meaningless "(16)". Show the span instead.
  function syncSummary(group) {
    var sel = group.querySelector('.facets__selected');
    if (!sel) return;
    var name = paramNameOf(group);
    if (!name) return;
    var nums = checkedNums(group, name);
    var t = nums.length
      ? ' (' + fmt(nums[0]) + ' ' + DASH + ' ' + fmt(nums[nums.length - 1]) + ')'
      : '';
    // Write only on change: run() must stay idempotent for the observer.
    if (sel.textContent !== t) sel.textContent = t;
  }

  function clearName(form, name) {
    if (!form) return;
    var group = null;
    form.querySelectorAll('input[type="checkbox"]').forEach(function (b) {
      if (b.name === name && b.checked) {
        b.checked = false;
        if (!group) group = b.closest('.js-filter');
      }
    });
    if (group) fireUpdate(group);
  }

  function setChipText(chip, text) {
    var inner = chip.querySelector('.active-facets__button-inner') || chip.querySelector('a');
    if (!inner) return;
    var walker = document.createTreeWalker(inner, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) { node.nodeValue = ' ' + text + ' '; return; }
    }
    inner.insertBefore(document.createTextNode(' ' + text + ' '), inner.firstChild);
  }

  function syncChips() {
    var cur = filterCounts(location.search);

    document.querySelectorAll('.active-facets').forEach(function (af) {
      var form = formFor(af);
      var buckets = {};

      af.querySelectorAll('facet-remove').forEach(function (fr) {
        if (fr.classList.contains(CHIP_CLASS)) return;
        var a = fr.querySelector('a.active-facets__button--light');
        if (!a) return; // "Remove all" link
        var name = reducedName(cur, a.getAttribute('href') || '');
        if (!name || !isRangeName(name)) return;
        var bk = buckets[name] || (buckets[name] = { nodes: [], label: '' });
        bk.nodes.push(fr);
        if (!bk.label) {
          var t = (a.textContent || '').trim();
          var ci = t.indexOf(':');
          bk.label = ci === -1 ? t : t.slice(0, ci).trim();
        }
      });

      af.querySelectorAll('.' + CHIP_CLASS).forEach(function (c) {
        if (!buckets[c.getAttribute('data-name')]) c.remove();
      });

      Object.keys(buckets).forEach(function (name) {
        var bk = buckets[name];
        var nums = checkedNums(form, name);
        if (!nums.length) nums = checkedNums(document.getElementById('FacetFiltersForm'), name);
        if (!nums.length) return;

        var text = bk.label + ': ' + fmt(nums[0]) + ' ' + DASH + ' ' + fmt(nums[nums.length - 1]);
        var sig = name + '|' + text + '|' + bk.nodes.length;
        var exist = af.querySelector('.' + CHIP_CLASS + '[data-name="' + name + '"]');

        // Rebuild only on real change: run() must stay idempotent or it would
        // ping-pong with the MutationObserver below.
        if (!exist || exist.getAttribute('data-sig') !== sig) {
          if (exist) exist.remove();
          var chip = bk.nodes[0].cloneNode(true);
          chip.classList.add(CHIP_CLASS);
          chip.setAttribute('data-name', name);
          chip.setAttribute('data-sig', sig);
          chip.style.display = '';
          var a = chip.querySelector('a');
          if (a) {
            a.setAttribute('href', hrefWithout(name));
            a.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              clearName(formFor(af), name);
            }, true);
          }
          setChipText(chip, text);
          bk.nodes[0].parentNode.insertBefore(chip, bk.nodes[0]);
        }

        // Inline style, so hiding never shows up as a childList mutation.
        bk.nodes.forEach(function (fr) { fr.style.display = 'none'; });
      });
    });
  }

  function run() {
    document
      .querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter')
      .forEach(enhance);
    document
      .querySelectorAll('.js-filter[data-range-enhanced="1"]')
      .forEach(syncSummary);
    syncChips();
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(); }, 40);
  }

  function init() {
    run();
    // Desktop active-facets sits inside #FacetFiltersForm but the mobile one
    // does not, and Dawn can replace either wrapper wholesale on an AJAX
    // update - so observe the document and debounce. run() is idempotent.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
